module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "open-on-hover": "",
      "close-on-content-click": "",
      "nudge-width": 200,
      "offset-x": ""
    },
    model: {
      value: (_vm.showInfo),
      callback: function($$v) {
        _vm.showInfo = $$v
      },
      expression: "showInfo"
    }
  }, [_c('v-icon', _vm._b({
    attrs: {
      "slot": "activator",
      "small": _vm.small,
      "color": _vm.color
    },
    slot: "activator"
  }, 'v-icon', _vm.iconAttrs, false), [_vm._v(_vm._s(_vm.icon))]), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "width": "250px"
    }
  }, [_c('v-card-text', [_vm._t("default")], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1ed8030","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/HelpPopover.vue
// module id = 1525
// module chunks = 9